import { MedicareConsent } from '@/consent/medicare/domain/MedicareConsent';
import { MedicareConsentRepository } from '@/consent/medicare/domain/MedicareConsentRepository';
import { UseCase } from '@/shared/application/UseCase';
import { ServicesApiResponse } from '@hfc/ui-core';
import { UUID } from '@hfc/common/src/types/UUID';

export class GetConsentUseCase implements UseCase<UUID, ServicesApiResponse<MedicareConsent>> {

  private repository: MedicareConsentRepository;

  public constructor (repository: MedicareConsentRepository) {
    this.repository = repository;
  }

  public async run (uuid: UUID): Promise<ServicesApiResponse<MedicareConsent>> {
    return await this.repository.getMedicareConsent(uuid);
  }

}
